/* Empty-state kit (.empty) from handoff/03-design/kits/empty-kit.html. */
.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 32px 24px;
  border: 1px dashed var(--border-dashed);
  border-radius: var(--radius-md);
  background: linear-gradient(180deg, var(--white) 0%, var(--gray-50) 100%);
  text-align: center;
}

.sm {
  gap: 8px;
  padding: 20px 18px;
}

.headline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: var(--text-heading);
  font-family: var(--font-display);
  font-size: 20px;
  font-weight: var(--fw-medium);
  line-height: 1.2;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

.sm .headline {
  font-size: 17px;
}

.body {
  max-width: 420px;
  margin: 0;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.6;
}

.check {
  display: inline-grid;
  flex: none;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--brand-gold);
  color: var(--brand-navy-950);
}

.action {
  margin-top: 4px;
}

/* Not set yet: greyed, with the way to set it. */
.notSet {
  border-color: var(--border-control);
  background: var(--surface-ground);
}

.notSet .art {
  filter: grayscale(0.85);
  opacity: 0.75;
}

.notSet .headline {
  color: var(--gray-700);
}

/* On a dark ground (.empty-dark). */
.onDark {
  border-color: var(--white-a22);
  background: var(--white-a04);
}

.onDark .headline {
  color: var(--white);
}

.onDark .body {
  color: var(--brand-mist-200);
}

/* Illustrations */
.art {
  display: block;
  flex: none;
  width: 120px;
  height: 96px;
}

.artSm {
  width: 84px;
  height: 68px;
}

.float {
  animation: floaty 4s ease-in-out infinite;
}

@keyframes floaty {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-4px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .float {
    animation: none;
  }
}

:global(html[data-motion='reduced']) .float {
  animation: none;
}

/* Photo empty state for celebration places (employee Home, My recognition). */
.photo {
  position: relative;
  display: flex;
  align-items: flex-end;
  min-height: 220px;
  overflow: hidden;
  border-radius: var(--radius-md);
  color: var(--white);
}

.photo img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: saturate(0.6);
}

.photo::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 1;
  background: linear-gradient(0deg, var(--navy-a88) 0%, var(--navy-a35) 70%);
}

.photoText {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
}

.photoEyebrow {
  color: var(--brand-gold);
}

.photoHeadline {
  margin: 0;
  font-size: 26px;
  line-height: 1.1;
}

.photoBody {
  margin: 0;
  color: var(--text-on-dark-soft);
  font-size: 14px;
}

.photoAction {
  margin-top: 8px;
}
